// @ts-nocheck
import { menuDrawerGetProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const props = menuDrawerGetProps({
    backgroundColor: "common.background",
    color: "text.linkAlt",
    hoverColor: "text.linkAltHover",
    borderColor: "common.borderLight", // Store Custom Code
});

const drawer: Styleguide["drawer"] = {
    defaultProps: {
        headlineTypographyProps: {
            forwardAs: "span",
            variant: null as any,
            // "css" cannot be used here, use "cssOverrides/headlineTypography" instead
        },
        closeButtonProps: props.closeButton,
        closeButtonIconProps: props.closeButtonIcon,
        cssOverrides: {
            drawerBody: props.wrapperCss,
            drawerTitle: props.headerCss,
            headlineTypography: css`
                flex: 1 1 auto;
                text-transform: none; /* Store Custom Code */
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                ${({ theme }) => css`
                    padding: ${pxToRem(24) /* Store Custom Code */};
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.small};
                    font-size: ${pxToRem(20) /* Store Custom Code */};
                `}

                padding-top: 0;
                padding-right: 0;
                padding-bottom: 0;
            `,
        },
    },
};

export default drawer;
